import React, { useState, useEffect, useCallback } from "react";
import { Marker, Popup } from "react-map-gl";
import { VStack, Heading, Text, Skeleton } from "@chakra-ui/react";
import { PinGateway } from "./Pin";
import useAxios from "../../utils/useAxios";
import { useToast } from "@chakra-ui/react";

import { calculateBatteryLevel } from "../../views/gateways/GatewaysViewPublic";
import { IGateway } from "../../types/deviceInterface";

const RenderGateways: React.FC = () => {
  const api = useAxios();
  const [gateways, setGateways] = useState<IGateway[]>([]);
  const [loading, setLoading] = useState(true);
  const [selected, setSelected] = useState<IGateway | null>(null);
  const toast = useToast();

  useEffect(() => {
    try {
      api.get<IGateway[]>("frontend/gateways/").then((res) => {
        const withCoords = res.data.filter((g) => g.latitude != null && g.longitude != null);
        setGateways(withCoords);
      });
    } catch (error) {
      toast({ title: "Error fetching data", status: "error", duration: 9000, isClosable: true });
    } finally {
      setLoading(false);
    }
  }, []);

  return (
    <>
      {gateways.map((gw) => (
        <Marker
          key={gw.id}
          latitude={gw.latitude!}
          longitude={gw.longitude!}
          anchor="bottom"
          onClick={(e) => {
            e.originalEvent.stopPropagation();
            setSelected(gw);
          }}
        >
          <PinGateway size={30} pinColor={"#007ACC"} iconColor="white" />
        </Marker>
      ))}

      {selected && (
        <Popup
          anchor="top"
          latitude={selected.latitude!}
          longitude={selected.longitude!}
          onClose={() => setSelected(null)}
          closeOnClick={true}
          maxWidth="200px"
        >
          <VStack align="start" spacing={1}>
            <Heading size="sm">{selected.gateway_name || "Gateway"}</Heading>
            <Text>
              Battery:{" "}
              {selected.gateway_battery_voltage &&
                calculateBatteryLevel(selected.gateway_battery_voltage)}{" "}
              %
            </Text>
            <Text>Devices: {selected.number_of_devices}</Text>
            <Text>Messages: {selected.number_of_messages_last_hour}</Text>
          </VStack>
        </Popup>
      )}
      {loading && <Skeleton pos="absolute" w="100%" h="100%" />}
    </>
  );
};

export default RenderGateways;
